import './utils/logBuffer';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './state/store';
import App from './App'
import './index.css';
import { registerServiceWorker } from './browser/serviceWorker';
import { initTelLaunch } from './browser/telLaunch';

registerServiceWorker();
initTelLaunch();

// In the installed app Chrome renders "app name - document.title" in the
// title bar; matching them exactly makes it show the app name once. The
// longer tab title stays for browser tabs/bookmarks.
if (window.matchMedia('(display-mode: standalone)').matches) {
  document.title = 'Comet Web Application - Blink Voice';
}


const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);